import Page from '../page';

export default class MasterIndex extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/master/master-index.js